module.exports = __webpack_public_path__ + "static/img/poster-img.2ca6ea1.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/poster-img.png
// module id = x8W/
// module chunks = 0